export default {
  hello: "Ein neues $bomify Projekt ist am Start :D",
  developed_by: "Entwickelt von <a href='https://bambus-software.ch' target='_blank' noopener noreferrer>Bambus Software</a> und <a href='https://polygon-software.ch/' target='_blank' noopener noreferrer>PolygonSoftware</a>",
};
